import FieldEdit from "../components/FieldEdit.jsx";

function FieldCreatePage() {
  return <FieldEdit method="post" />;
}

export default FieldCreatePage;
